import { t, tf } from "./i18n.js";
const MAX_SECURE_PLAYERS = 8;

// ---------------------------------------------------------------------------
// EINZELDARTS (15.08.2026)
//
// Bis hierher merkte sich Secure nur ZAHLEN: currentRawScore, secureMultiplier
// und zwei Zaehler. Womit sie zustande kamen, war weg, sobald der Knopf
// gedrueckt war. Solange ein Mensch tippt, geht das - er weiss ja, was er
// eingegeben hat. Mit dem Tracker nicht mehr: Ein falsch erkanntes Triple war
// weder sichtbar noch zu berichtigen.
//
// Jetzt stehen die Wuerfe einzeln in zwei Listen, und alles andere wird
// daraus BERECHNET (secureNeuBerechnen). Damit ist eine Korrektur nur ein
// Ersetzen in der Liste - es gibt keinen zweiten Ort, an dem die alte Zahl
// noch steckt.
// ---------------------------------------------------------------------------
let secureWuerfe = [];      // Phase 1: { m, label, quelle }
let secureBullWuerfe = [];  // Phase 2: { t, label, quelle }
let secureGewaehlt = null;  // { phase: 1|2, index } - der Dart, der ersetzt wird
let secureAutoTimer = null;
// Phase 1 ist vorbei, auch wenn keine drei Pfeile erkannt wurden (Pfeile
// gezogen). Ohne diese Flagge blieb die Runde bei zwei erkannten Darts
// stehen - genau der Fall, den drei Bullseyes erzeugen.
let securePhase1Beendet = false;
// Ist dieses Spiel vorbei? Der Riegel gegen den mehrfachen Abschluss
// (siehe nextTurn). Wird ausschliesslich in startGame() geloescht.
let secureSpielBeendet = false;

/** Beschriftung eines Phase-1-Darts. `m` ist der Multiplikator auf dem Ziel. */
function secureLabel1(m, ziel) {
  if (!m) return "MISS";
  if (ziel === 25) return m === 2 ? "B-EYE" : "BULL";
  if (ziel === 50) return "B-EYE";
  return (m === 3 ? "T" : m === 2 ? "D" : "") + ziel;
}

/** Beschriftung eines Phase-2-Darts. */
function secureLabel2(t) {
  return t === 2 ? "B-EYE" : t === 1 ? "BULL" : "MISS";
}

/** Punktestand, Sicherung und Zaehler aus den beiden Listen neu ableiten.
 *
 *  EINE Rechnung an EINER Stelle. Die Staffelung des Multiplikators haengt
 *  an der Reihenfolge (25 addiert, 50 verdoppelt) - deshalb wird sie hier
 *  nachgespielt statt fortgeschrieben. Nach einer Korrektur stimmt sie
 *  damit auch dann, wenn der ERSTE Dart geaendert wurde. */
function secureNeuBerechnen() {
  const ziel = targets[globalTargetIndex];
  currentRawScore = 0;
  for (const w of secureWuerfe) currentRawScore += ziel * w.m;

  isSecured = false;
  isDoubleHit = false;
  secureMultiplier = 0;
  for (const w of secureBullWuerfe) {
    if (w.t === 1) {
      isSecured = true;
      secureMultiplier = secureMultiplier === 0 ? 1 : secureMultiplier + 1;
    } else if (w.t === 2) {
      isSecured = true;
      isDoubleHit = true;
      secureMultiplier = secureMultiplier === 0 ? 2 : secureMultiplier * 2;
    }
  }

  thrownScore = secureWuerfe.length;
  thrownSecure = secureBullWuerfe.length;
}

// FIX: Baut den Setup-Chip per textContent statt per innerHTML-Konkatenation.
// Vorher wurde der Spielername als HTML interpretiert.
function appendSecurePlayerChip(name, isVerified) {
  const list = document.getElementById("player-list-setup");
  if (!list) return;
  const chip = document.createElement("div");
  chip.style.cssText = isVerified
    ? "background:#10b981; color:black; padding:5px; margin:5px; display:inline-block; border-radius:5px; font-weight:bold;"
    : "background:#333; padding:5px; margin:5px; display:inline-block; border-radius:5px;";
  chip.textContent = isVerified ? `${name} ✓` : name;
  list.appendChild(chip);
}

function addPlayer() {
  const input = document.getElementById("player-input");
  const name = input.value.trim();
  if (!name) return;

  // FIX: Doppelte Namen brachen die Siegerermittlung in handleGameEnd(),
  // weil dort ueber p.name === winner.name verglichen wird.
  if (players.some((p) => p.name.toLowerCase() === name.toLowerCase())) {
    if (typeof showToast === "function")
      showToast(t("js.gotcha.002"), "error");
    return;
  }
  if (players.length >= MAX_SECURE_PLAYERS) {
    if (typeof showToast === "function")
      showToast(tf("js.secure.010", { p1: MAX_SECURE_PLAYERS }), "error");
    return;
  }

  // NEU: Prüfen, ob der eingegebene Name der eingeloggte Host ist
  let p_user_id = null;
  if (!isGuest && currentUser && name === myOnlineName) {
    p_user_id = currentUser.id;
  }

  players.push({
    isBot: false,
    name: name,
    user_id: p_user_id, // <--- HIER: ID wird gespeichert (oder bleibt null für unregistrierte Gäste)
    score: 0,
    stats: { rounds: 0, secures: 0, doubles: 0, numberData: {} },
    matchLog: [],
  });

  appendSecurePlayerChip(name, !!p_user_id);
  input.value = "";
}

function addVerifiedPlayer() {
  // Wir öffnen das neue Input-Modal und warten auf den Code
  openPairingInputModal(async (code) => {
    // Code ans Backend senden zur Prüfung
    const { data, error } = await _supabase.rpc("verify_pairing_code", {
      p_code: code,
    });

    if (error || !data || data.length === 0) {
      if (typeof showToast === "function")
        showToast(t("js.g501.018"), "error");
      return;
    }

    // data[0] enthält name und user_id aus der Datenbank
    const guestData = data[0];

    // FIX: Auch verifizierte Gaeste duerfen nicht doppelt in der Liste stehen.
    if (
      players.some(
        (p) =>
          (p.user_id && p.user_id === guestData.user_id) ||
          p.name.toLowerCase() === String(guestData.name).toLowerCase(),
      )
    ) {
      if (typeof showToast === "function")
        showToast(t("js.gotcha.002"), "error");
      return;
    }

    // Gast sicher in die Liste aufnehmen
    players.push({
      isBot: false,
      name: guestData.name,
      user_id: guestData.user_id, // Die sichere ID aus der Datenbank
      score: 0,
      stats: { rounds: 0, secures: 0, doubles: 0, numberData: {} },
      matchLog: [],
    });

    // Optisches Feedback in der Setup-Liste (Grüner Kasten mit Häkchen)
    // FIX: Der Name kommt aus der DB und wurde vorher als HTML interpretiert.
    appendSecurePlayerChip(guestData.name, true);

    if (typeof showToast === "function") {
      showToast(tf("js.secure.verifiziert", { p1: guestData.name }), "success");
    }
  });
}

// FIX: prompt() ersetzt durch ein Auswahl-Modal. Der Nutzer musste vorher
// eine Ziffer abtippen, statt die Stufe anzuklicken.
//
// UMBAU 15.08.2026: Die drei fest verdrahteten Stufen (1, 2, 3) sind durch
// die gemeinsame Stufenliste aus bot.js ersetzt. Die Auswahl wird daraus
// ERZEUGT - eine neue Stufe erscheint hier, ohne dass diese Datei davon
// wissen muss. Gespeichert wird nicht mehr eine Stufennummer, sondern der
// Ziel-Average; damit steht ein Secure-Bot auf derselben Skala wie ein
// 501-Bot.
function addBot() {
  const stufen = window.BOT_STUFEN || [];
  showChoiceModal(
    t("js.secure.001"),
    t("js.secure.002"),
    stufen.map((stufe) => ({
      label: `${t("bot.stufe." + stufe.id)} · \u00d8 ${stufe.avg}`,
      value: stufe.avg,
      accent: stufe.akzent,
    })),
    (avg) => addBotWithDifficulty(avg),
  );
}

/** Bot mit einem Ziel-Average aufnehmen.
 *
 *  Der Parameter hiess frueher `diff` und war 1, 2 oder 3. Alte Aufrufe mit
 *  einer dieser Zahlen kommen trotzdem an: Sie liegen weit unter dem
 *  kleinsten Average und werden auf die zugehoerige Stufe umgesetzt - sonst
 *  stuende nach dem Umbau ein Bot mit "Average 2" im Spiel. */
function addBotWithDifficulty(avg) {
  const ALTE_STUFEN = { 1: 30, 2: 60, 3: 120 };
  const wert = window.begrenzeAvg(ALTE_STUFEN[avg] ?? avg);
  const stufe = window.stufeFuerAvg(wert);
  // BEFUND 17.08.2026: Hier stand `botSvg + "..."`. Der Name eines Bots
  // trug damit 380 Zeichen SVG-Quelltext mit sich. Ueberall, wo ein Name
  // als TEXT ausgegeben wird - Sieger-Toast (ui-kit.js: textContent),
  // Karussell (ui.js: textContent) - stand statt "Freizeit [BOT] \u00d845" die
  // ganze Grafik als Quelltext. Genau das war die "kryptische" Anzeige.
  //
  // Der Name ist jetzt reiner TEXT. Das Symbol kommt dort dazu, wo Markup
  // erlaubt ist (Chip, Namenszeile, Rangliste) - aus `isBot`, nicht aus
  // dem Namen.
  const name = `${t("bot.stufe." + stufe.id)} [BOT] \u00d8${wert}`;
  players.push({
    isBot: true,
    botAvg: wert,
    name: name,
    score: 0,
    stats: { rounds: 0, secures: 0, doubles: 0, numberData: {} },
    matchLog: [],
  });
  const list = document.getElementById("player-list-setup");
  if (list) {
    const chip = document.createElement("div");
    chip.style.cssText =
      "background:#673ab7; padding:5px; margin:5px; display:inline-block; border-radius:5px;";
    // Symbol als Markup, Name als Text - der Name kann so nie als HTML
    // gelesen werden, auch wenn er spaeter einmal aus der Datenbank kommt.
    chip.innerHTML = botSvg;
    chip.appendChild(document.createTextNode(name));
    list.appendChild(chip);
  }
}

/** Name eines Spielers als reiner Text - fuer Toasts, Karussell, Ansagen.
 *
 *  Alte Spielstaende (Online-Sync, gespeicherter Verlauf) koennen noch
 *  einen Namen MIT eingebettetem SVG tragen. `pName` raeumt das weg, damit
 *  ein alter Stand nicht wieder die Quelltextwand zeigt. */
function secureName(p) {
  return pName(p);
}

/** Name mit Bot-Symbol - nur fuer Stellen, an denen Markup erlaubt ist.
 *
 *  Der Name wird dabei escaped: Er stammt bei Menschen aus einer Eingabe
 *  bzw. aus der Datenbank und darf nie als HTML gelesen werden. */
function secureNameHtml(p) {
  const roh = document.createElement("span");
  roh.textContent = secureName(p);
  return (p?.isBot ? botSvg : "") + roh.innerHTML;
}

function startGame() {
  // Spielwache: nur die Verlassen-Warnung (29.08.2026), s. game-501.js.
  spielwacheSpielGestartet("secure", null);

  // Kurzmodus (10-Bull): dieselbe Leiter, aber Start erst bei der 10.
  // targets = [1..20, 25, 50] -> Index 9 ist die 10.
  const chkShort = document.getElementById("chk-short-mode");
  isShortMode = chkShort ? chkShort.checked : false;

  if (players.length === 0)
    return showToast(t("js.secure.004"), "warning");

  // ENTFALLEN 15.08.2026: der Haken "Training / Separat speichern". Ob ein
  // Durchgang Training ist, entscheidet jetzt der MODUS (app.js,
  // MODUS_GRUPPE) - und Secure steht unter "Spielen".
  //
  // Die Zwei-Spieler-Pflicht haengt bewusst NICHT mehr daran. Sie war frueher
  // mit "!isTrainingMode" verknuepft, der Haken war also das Einzige, was
  // Ueben allein erlaubte - eine versteckte Kopplung zweier Dinge, die
  // nichts miteinander zu tun haben. Secure allein zu spielen bleibt
  // erlaubt; gewertet wird es wie jedes andere Spiel.
  // 1. Reset variables safely
  setzeAppModus("secure");
  secureSpielBeendet = false;
  currentPlayerIndex = 0;
  globalTargetIndex = isShortMode ? Math.max(0, targets.indexOf(10)) : 0;

  document.body.classList.remove("training-active");
  // FIX: Hier stand "Secure-Darts" - das Original im Header heisst aber
  // "SECURE DARTS". Der eigentliche Ruecksetz-Punkt ist goHome() in app.js.
  const titleEl = document.getElementById("app-title");
  if (titleEl) titleEl.innerText = "SECURE DARTS";

  // 2. Prevent WakeLock crashes (often fails on local/HTTP testing)
  try {
    if (typeof requestWakeLock === "function") {
      requestWakeLock();
    }
  } catch (e) {
    console.warn("WakeLock skipped/not supported:", e);
  }

  // 3. Screens ausblenden. Frueher stand hier eine zweite, handgepflegte
  //    Screen-Liste, die mit ALL_SCREENS in app.js auseinandergelaufen ist
  //    (121, Cricket, Random und die Secure-Lobby fehlten) - dadurch blieben
  //    Screens sichtbar und ueberlagerten sich. Jetzt gibt es nur noch
  //    eine Quelle der Wahrheit.
  hideAllScreens();

  // 4. Forcefully display the Secure game screen
  const secureScreen = document.getElementById("game-secure-screen");
  if (secureScreen) {
    secureScreen.style.display = "block";
  } else {
    console.error("Critical: The Game-Secure-Screen HTML element is missing!");
  }

  // 5. Safely load the UI
  try {
    updateUI();
    resetTurnInputs();
    checkBotTurn();
  } catch (error) {
    console.error("Error during UI update:", error);
  }
}

function checkBotTurn() {
  const p = players[currentPlayerIndex];
  if (p.isBot) {
    document.getElementById("bot-overlay").style.display = "flex";
    document.getElementById("bot-panic-btn").style.display = "block";
    document.getElementById("bot-status-text").innerText = `${pName(
      p,
    )} zielt...`;
    document.getElementById("btn-undo").style.display = "none";
    if (botTimer) clearTimeout(botTimer);
    botTimer = setTimeout(() => {
      document.getElementById("bot-panic-btn").style.display = "none";
      playBot(p);
    }, 2500);
  } else {
    document.getElementById("bot-overlay").style.display = "none";
    updateUndoButtonVisibility();
  }
}

function cancelBotAndUndo() {
  if (botTimer) clearTimeout(botTimer);
  document.getElementById("bot-overlay").style.display = "none";
  undoLastTurn();
}

/** Der Ziel-Average eines Bots.
 *
 *  Bots aus einem laufenden Spielstand (Online-Sync, gespeicherter Verlauf)
 *  koennen noch die alte `difficulty` 1/2/3 tragen. Sie wird hier auf die
 *  Skala umgesetzt, statt an drei Stellen abgefragt zu werden. */
function botAvgVon(bot) {
  if (Number.isFinite(Number(bot?.botAvg))) return window.begrenzeAvg(bot.botAvg);
  const ALTE_STUFEN = { 1: 30, 2: 60, 3: 120 };
  return window.begrenzeAvg(ALTE_STUFEN[bot?.difficulty] ?? 60);
}

/** Die Punktrunde des Bots: drei Darts auf die Zielzahl.
 *
 *  UMBAU 15.08.2026: Hier standen 18 rohe Wahrscheinlichkeiten in drei
 *  Zweigen (`if (rnd > 0.6) hit = 1`), einmal fuer Zahlen und einmal fuer
 *  das Bull. Sie waren nur hier gueltig und mit nichts vergleichbar. Jetzt
 *  fragt der Bot dasselbe Modell wie im 501 (bot.js, wurfAufZahl) - er
 *  bekommt richtige Darts statt blosser Multiplikatoren, und das Spiel
 *  rechnet daraus wie bisher die Rohpunkte.
 *
 *  Der Bot bleibt Handeingabe (keine `quelle`-Auswertung): Er ist kein
 *  Tracker, und die Runde soll wie bisher vom Ablauf bestaetigt werden. */
function playBot(bot) {
  const avg = botAvgVon(bot);
  const targetVal = targets[globalTargetIndex];

  // KORREKTUR 17.08.2026: Hier wurden `currentRawScore` und `thrownScore`
  // frueher DIREKT gesetzt, an secureNeuBerechnen() vorbei. Zwei Folgen:
  //
  //   1. Die drei Kacheln blieben beim Bot leer ("–"). Man sah eine Zahl,
  //      aber nicht, woraus sie entstand.
  //   2. Die Sicherungsrunde rechnete nach einer ANDEREN Regel als die
  //      Handeingabe (siehe playBotSecure).
  //
  // Jetzt legt der Bot dieselben Wuerfe in dieselben Listen wie ein Mensch
  // und laesst dieselbe Funktion rechnen. Es gibt nur noch EINE Regel.
  secureWuerfe = [];
  for (let i = 0; i < 3; i++) {
    const dart = window.wurfAufZahl(avg, targetVal);
    // Gezaehlt wird nur, was die ZIELZAHL getroffen hat. Ein Fehlwurf ist
    // 0; beim Bull zaehlt das Bullseye doppelt (25 -> 50 ist "zweimal die
    // 25"), so wie es die Handeingabe auch tut.
    let m = 0;
    if (dart.base === targetVal) m = dart.mult;
    else if (targetVal === 25 && dart.base === 50) m = 2;
    secureWuerfe.push({ m, label: secureLabel1(m, targetVal), quelle: "bot" });
  }
  securePhase1Beendet = true;
  secureNeuBerechnen();
  updateTurnDisplay();

  const status = document.getElementById("bot-status-text");
  if (currentRawScore === 0) {
    if (status) status.innerText = tf("js.secure.botnull", { p1: pName(bot) });
    botTimer = setTimeout(() => nextTurn(), 2000);
  } else {
    if (status)
      status.innerText = tf("js.secure.botpunkte", {
        p1: pName(bot),
        p2: currentRawScore,
      });
    botTimer = setTimeout(() => playBotSecure(bot), 1500);
  }
}

/** Die Sicherungsrunde des Bots: drei Darts auf das Bull.
 *
 *  KORREKTUR 17.08.2026 - hier stand die zweite, ABWEICHENDE Staffelung:
 *
 *      if (tempMultiplier === 0) tempMultiplier = 1;
 *      if (dart.base === 50) tempMultiplier *= 2;
 *
 *  Ein Mensch bekommt fuer jedes weitere Bull +1 (secureNeuBerechnen);
 *  der Bot bekam fuer drei Bulls denselben Multiplikator wie fuer eines.
 *  Zwei Regeln fuer dasselbe Spiel - und die schlechtere galt fuer den
 *  Gegner. Jetzt schreibt auch der Bot nur noch seine Wuerfe auf. */
function playBotSecure(bot) {
  const avg = botAvgVon(bot);
  secureBullWuerfe = [];
  for (let i = 0; i < 3; i++) {
    const dart = window.wurfAufZahl(avg, 25);
    const bull = dart.base === 50 ? 2 : dart.base === 25 ? 1 : 0;
    secureBullWuerfe.push({ t: bull, label: secureLabel2(bull), quelle: "bot" });
  }
  secureNeuBerechnen();
  updateTurnDisplay();

  let txt = t("js.secure.016");
  if (isSecured) txt = t("js.secure.017");
  if (secureMultiplier > 1) txt = tf("js.secure.botbulls", { p1: secureMultiplier });
  const status = document.getElementById("bot-status-text");
  if (status) status.innerText = `${pName(bot)} ${txt}`;
  botTimer = setTimeout(() => nextTurn(), 1500);
}

function pName(p) {
  // Cleans out the SVG tag entirely using Regex, leaving just the text
  return p.name.replace(/<[^>]*>?/gm, "").trim() || p.name;
}

function saveState() {
  const state = {
    players: JSON.parse(JSON.stringify(players)),
    currentPlayerIndex: currentPlayerIndex,
    globalTargetIndex: globalTargetIndex,
  };
  gameHistoryStack.push(state);
  if (gameHistoryStack.length > 10) gameHistoryStack.shift();
}

function undoLastTurn() {
  // Online kein Undo: der Verlauf existiert nur lokal (siehe
  // updateUndoButtonVisibility). Der Button ist dann zwar ausgeblendet,
  // aber so ist die Funktion auch gegen direkte Aufrufe abgesichert.
  if (typeof isSecureOnline !== "undefined" && isSecureOnline) return;
  if (gameHistoryStack.length === 0) return;
  const lastState = gameHistoryStack.pop();
  players = lastState.players;
  currentPlayerIndex = lastState.currentPlayerIndex;
  globalTargetIndex = lastState.globalTargetIndex;
  resetTurnInputs();
  updateUI();
  updateUndoButtonVisibility();
  if (players[currentPlayerIndex].isBot) checkBotTurn();
}

function updateUndoButtonVisibility() {
  const btn = document.getElementById("btn-undo");
  if (!btn) return;
  // Online wird der Verlauf nicht synchronisiert - ein lokales Undo wuerde
  // die Staende der Clients auseinanderlaufen lassen. Deshalb ausblenden.
  if (typeof isSecureOnline !== "undefined" && isSecureOnline) {
    btn.style.display = "none";
    return;
  }
  if (gameHistoryStack.length === 0 || players[currentPlayerIndex].isBot) {
    btn.style.display = "none";
    return;
  }
  const lastState = gameHistoryStack[gameHistoryStack.length - 1];
  const previousPlayer = lastState.players[lastState.currentPlayerIndex];
  if (previousPlayer.isBot) {
    btn.style.display = "none";
  } else {
    btn.style.display = "block";
  }
}

async function nextTurn() {
  // BEFUND 17.08.2026 - "Endlosschleife": Das Spiel endete nie wirklich.
  // handleGameEnd() zeigte einen Toast und schrieb die Statistik, liess
  // aber ALLES stehen: denselben Spieler am Zug, dieselbe gesicherte Runde,
  // dieselbe Zielstufe, den Screen offen. Jeder weitere Druck auf
  // "Bestaetigen" lief erneut in denselben Zweig - im Browsertest nach vier
  // Druecken 600 statt 150 Punkte und vier Sieger-Toasts, und je Durchlauf
  // ein weiteres process_match_results.
  //
  // Diese Zeile ist der Riegel: Nach dem Ende nimmt der Modus keine Zuege
  // mehr an. Zurueckgesetzt wird er nur beim Start eines neuen Spiels.
  if (secureSpielBeendet) return;
  // Online: "Bestaetigen" ist nur fuer den Spieler am Zug erlaubt. addRawScore/
  // addSecure pruefen das bereits - nextTurn war die letzte offene Luecke.
  if (!secureInputAllowed()) return;
  saveState();
  const p = players[currentPlayerIndex];
  p.stats.rounds++;
  if (isSecured) p.stats.secures++;
  if (isDoubleHit) p.stats.doubles++;
  let tVal = targets[globalTargetIndex];
  let key = tVal.toString();
  if (!p.stats.numberData[key])
    p.stats.numberData[key] = { points: 0, count: 0 };
  p.stats.numberData[key].points += currentRawScore;
  p.stats.numberData[key].count += 1;
  let final = isSecured ? currentRawScore * secureMultiplier : 0;
  p.matchLog.push({
    target: tVal,
    raw_score: currentRawScore,
    secured: isSecured,
    multiplier: secureMultiplier,
    final_points: final,
  });
  if (isSecured) {
    if (globalTargetIndex < targets.length - 1) globalTargetIndex++;
    else {
      p.score += final;
      await handleGameEnd();
      return;
    }
  }
  p.score += final;
  currentPlayerIndex = (currentPlayerIndex + 1) % players.length;
  resetTurnInputs();
  updateUI();

  // Online: Spielstand an den Gegner senden, statt einen Bot zu ziehen
  if (typeof isSecureOnline !== "undefined" && isSecureOnline) {
    await pushSecureState({ last_action: tf("js.secure.011", { p1: secureName(p), p2: final }) });
    updateSecureTurnLock();
    return;
  }

  checkBotTurn();
}

async function handleGameEnd() {
  // Zweiter Riegel, unabhaengig von nextTurn: handleGameEnd darf je Spiel
  // GENAU EINMAL laufen. Sonst haengt an jedem weiteren Aufruf ein
  // Datenbankschreiben.
  if (secureSpielBeendet) return;
  secureSpielBeendet = true;

  // Ein laufender Bot-Zug darf nicht ins beendete Spiel hineinfeuern.
  if (botTimer) {
    clearTimeout(botTimer);
    botTimer = null;
  }
  if (secureAutoTimer) {
    clearTimeout(secureAutoTimer);
    secureAutoTimer = null;
  }

  // BUGFIX: Spieler nach Punkten absteigend sortieren, um den WAHREN Sieger zu ermitteln
  const sortedPlayers = [...players].sort((a, b) => b.score - a.score);
  const winner = sortedPlayers[0];
  // FIX: Vergleich ueber die Objektreferenz. Bei gleichnamigen Spielern haben
  // vorher beide isWin=true bekommen.
  const winnerRef = winner;

  const botOverlay = document.getElementById("bot-overlay");
  if (botOverlay) botOverlay.style.display = "none";
  // secureName statt winner.name: Der Toast schreibt mit textContent. Stand
  // im Namen ein SVG, las man 380 Zeichen Quelltext statt "Freizeit [BOT]".
  showToast(
    tf("js.secureonline.017", { p1: secureName(winner), p2: winner.score }),
    "success",
    5000,
  );

  // FIX (Race): Das eigene "finished"-Update kommt per Realtime-Echo zurueck
  // und leaveSecureOnline() leert players[] - je nach Timing bevor die
  // Statistik unten gebaut ist. Deshalb vorher einen Snapshot ziehen.
  const playersForPayload = [...players];

  // Online: Endstand einmal an alle verteilen, dann Raum schliessen.
  // Das Flag verhindert, dass der Ausloeser den Sieger-Toast doppelt
  // sieht (einmal hier, einmal durchs Echo in handleSecureRoomUpdate).
  if (typeof isSecureOnline !== "undefined" && isSecureOnline) {
    window.secureEndAnnounced = true;
    await pushSecureState({ status: "finished" });
  }

  const matchPayload = {
    mode: "secure",
    // Kommt aus dem Modus-Register (app.js, MODUS_GRUPPE), nicht mehr aus
    // einem Haken im Setup. Fuer Secure ist das immer false.
    is_training: !!window.isTrainingMode,
    players: [],
  };

  for (let p of playersForPayload) {
    if (p.isBot) continue;
    if (!p.user_id) continue;

    matchPayload.players.push({
      user_id: p.user_id,
      isWin: p === winnerRef,
      score: p.score,
      stats: p.stats,
      matchLog: p.matchLog,
    });
  }

  if (matchPayload.players.length > 0) {
    await _supabase.rpc("process_match_results", { payload: matchPayload });
  }

  // Online hat einen eigenen Abschluss: handleSecureRoomUpdate sperrt die
  // Eingabe und blendet die Revanche-Leiste ein. Offline gab es das nicht -
  // das Spielfeld blieb einfach bedienbar stehen. Genau diese Luecke ist der
  // sichtbare Teil der "Endlosschleife".
  if (typeof isSecureOnline !== "undefined" && isSecureOnline) return;
  zeigeSecureEndstand(sortedPlayers);
}

/** Den Riegel loesen - ein NEUES Spiel darf wieder Zuege annehmen.
 *
 *  Offline setzt startGame() die Flagge zurueck. Online gibt es aber einen
 *  zweiten Weg in ein neues Spiel: die Revanche (startSecureRematch) baut
 *  die Spielerliste selbst auf und ruft startGame() NICHT. Ohne diese
 *  Freigabe blieben nach einer Online-Revanche genau die Clients stumm, die
 *  das vorige Spiel beendet hatten - und nur die. Ein Fehler, den man erst
 *  im Spiel zu zweit sieht.
 *
 *  Auch die Eingabesperre des Endstands wird hier geloest; online setzt
 *  updateSecureTurnLock() sie danach passend neu. */
function secureSpielFreigeben() {
  secureSpielBeendet = false;
  const panel = document.getElementById("secure-input-area");
  if (panel) {
    panel.style.opacity = "";
    panel.style.pointerEvents = "";
  }
}

/** Der Abschluss offline: Eingabe sperren, Endstand zeigen, weiter oder raus.
 *
 *  Bewusst ein Dialog und kein weiterer Screen - der Endstand steht auf
 *  demselben Spielfeld, das man gerade gespielt hat, und die einzige Frage
 *  ist "nochmal oder Schluss?". */
function zeigeSecureEndstand(sortiert) {
  // Spielende: Warnung entschaerfen (spielwache.js, 29.08.2026).
  if (typeof spielwacheSpielBeendet === "function") spielwacheSpielBeendet();
  const panel = document.getElementById("secure-input-area");
  if (panel) {
    panel.style.opacity = "0.45";
    panel.style.pointerEvents = "none";
  }
  const undo = document.getElementById("btn-undo");
  if (undo) undo.style.display = "none";

  const liste = sortiert
    .map((p, i) => `${i + 1}. ${secureName(p)} — ${p.score}`)
    .join("\n");

  if (typeof showChoiceModal !== "function") return;
  showChoiceModal(
    tf("js.secure.endetitel", { p1: secureName(sortiert[0]) }),
    liste,
    [
      { label: t("js.secure.enderevanche"), value: "revanche", accent: "accent-green" },
      { label: t("js.secure.endeschluss"), value: "schluss" },
    ],
    (wahl) => (wahl === "revanche" ? secureRevanche() : secureBeenden()),
  );
}

/** Dieselben Spieler, alles auf null. Die Reihenfolge bleibt. */
function secureRevanche() {
  const panel = document.getElementById("secure-input-area");
  if (panel) {
    panel.style.opacity = "";
    panel.style.pointerEvents = "";
  }
  for (const p of players) {
    p.score = 0;
    p.stats = { rounds: 0, secures: 0, doubles: 0, numberData: {} };
    p.matchLog = [];
  }
  gameHistoryStack = [];
  startGame();
}

/** Schluss: derselbe Aufraeumweg wie beim Abbrechen, nur ohne Rueckfrage -
 *  die Frage war der Dialog, aus dem dieser Aufruf kommt. */
function secureBeenden() {
  const panel = document.getElementById("secure-input-area");
  if (panel) {
    panel.style.opacity = "";
    panel.style.pointerEvents = "";
  }
  if (botTimer) {
    clearTimeout(botTimer);
    botTimer = null;
  }
  players = [];
  gameHistoryStack = [];
  currentPlayerIndex = 0;
  globalTargetIndex = 0;
  resetTurnInputs();
  const setupList = document.getElementById("player-list-setup");
  if (setupList) setupList.innerHTML = "";
  const botOverlay = document.getElementById("bot-overlay");
  if (botOverlay) botOverlay.style.display = "none";
  cancelCurrentGame("game-secure-screen", true);
}

async function saveProStats(name, pObj, isWin) {
  let { data: ex } = await _supabase
    .from("stats_secure")
    .select("*")
    .eq("name", name)
    .single();
  if (!ex) {
    await _supabase.from("stats_secure").insert([
      {
        name: name,
        wins: isWin ? 1 : 0,
        highscore: pObj.score,
        games_played: 1,
        total_points: pObj.score,
        rounds_played: pObj.stats.rounds,
        secure_count: pObj.stats.secures,
        double_count: pObj.stats.doubles,
        number_stats: pObj.stats.numberData,
      },
    ]);
  } else {
    let mStats = ex.number_stats || {};
    let cStats = pObj.stats.numberData;
    for (let k in cStats) {
      if (!mStats[k]) mStats[k] = { points: 0, count: 0 };
      mStats[k].points += cStats[k].points;
      mStats[k].count += cStats[k].count;
    }
    await _supabase
      .from("stats_secure")
      .update({
        wins: ex.wins + (isWin ? 1 : 0),
        highscore: Math.max(ex.highscore, pObj.score),
        games_played: (ex.games_played || 0) + 1,
        total_points: (ex.total_points || 0) + pObj.score,
        rounds_played: (ex.rounds_played || 0) + pObj.stats.rounds,
        secure_count: (ex.secure_count || 0) + pObj.stats.secures,
        double_count: (ex.double_count || 0) + pObj.stats.doubles,
        number_stats: mStats,
      })
      .eq("name", name);
  }
}

async function saveMatchHistory(name, pObj, isWin) {
  // Paket für die Datenbank schnüren
  let payload = {
    player_name: name,
    is_training: !!window.isTrainingMode, // s. o.: aus dem Modus-Register
    is_win: isWin,
    final_score: pObj.score,
    match_details: pObj.matchLog,
  };

  // NEU: user_id anhängen, falls ein Nutzer eingeloggt ist
  if (!isGuest && currentUser) {
    payload.user_id = currentUser.id;
  }

  const { error } = await _supabase
    .from("match_history_secure")
    .insert([payload]);

  if (error) {
    console.error(t("js.secure.006"), error.message);
  }
}

// Online: Eingaben nur, wenn dieser Client am Zug ist.
/** Phase + Wert eines Darts nach base/mult - EINE Wertungslogik fuer
 *  Tracker (autoscoreSecureDart) und Board-Klick (secureBoardWurf).
 *  Produkttest 29.08.2026: Vorher steckte die Zuordnung nur im
 *  Tracker-Adapter, die Handeingabe hatte kein Board. */
function secureDartEinordnen(base, mult) {
  const ziel = targets[globalTargetIndex];
  const phase = secureGewaehlt
    ? secureGewaehlt.phase
    : secureWuerfe.length < MAX_DARTS && !securePhase1Beendet
      ? 1
      : 2;
  if (phase === 1) {
    let m = 0;
    if (ziel === 25) m = base === 50 ? 2 : base === 25 ? 1 : 0;
    else if (ziel === 50) m = base === 50 ? 1 : 0;
    else if (base === ziel) m = mult;
    return { phase: 1, wert: m };
  }
  return { phase: 2, wert: base === 50 ? 2 : base === 25 ? 1 : 0 };
}

// ── Board-Eingabe (Produkttest 29.08.2026) ─────────────────────────────
let secureBoard = null;

function secureBoardWurf(treffer) {
  const base = Number(treffer?.base ?? 0);
  const mult = Number(treffer?.multiplier ?? 1);
  const zuordnung = secureDartEinordnen(base, mult);
  // addRawScore/addSecure tragen saemtliche Waechter (Gegner am Zug,
  // Kapazitaet, Korrektur ueber gewaehlte Kachel) - keine zweite Regel.
  if (zuordnung.phase === 1) addRawScore(zuordnung.wert, "hand");
  else addSecure(zuordnung.wert, "hand");
}

/** Board lazy aufbauen und das Zielfeld nachfuehren. Wird aus
 *  updateTurnDisplay() gerufen - dem einen Ort, an dem sich die Anzeige
 *  dieses Modus aendert (Sichtbarkeitsregel). */
function aktualisiereSecureBoard() {
  const halter = document.getElementById("secure-board");
  if (!halter || typeof createDartboard !== "function") return;
  if (!secureBoard) {
    secureBoard = createDartboard(halter, { onThrow: secureBoardWurf });
  }
  const phase = secureDartEinordnen(0, 0).phase;
  if (phase === 1) {
    const ziel = targets[globalTargetIndex];
    secureBoard.zeigeZiel(
      ziel === 25
        ? [{ base: 25 }, { base: 50 }]
        : ziel === 50
          ? [{ base: 50 }]
          : [{ base: ziel }],
    );
  } else {
    // Phase 2: Sichern auf das Bull.
    secureBoard.zeigeZiel([{ base: 25 }, { base: 50 }]);
  }
}

function secureInputAllowed() {
  if (typeof canInputSecure === "function" && !canInputSecure()) {
    showToast(t("js.secure.013"), "info");
    return false;
  }
  return true;
}

function addRawScore(m, quelle = "hand") {
  if (!secureInputAllowed()) return;
  const currentTarget = targets[globalTargetIndex];

  // --- NEU: Sicherheits-Check für Bull (25) und Bullseye (50) ---
  // Blockiert ungültige Multiplikatoren, egal woher der Aufruf kommt
  if (currentTarget === 25 && m > 2) return; // Kein Triple Single-Bull (max 2)
  if (currentTarget === 50 && m > 1) return; // Kein Double/Triple Bullseye (max 1)

  const wurf = { m, label: secureLabel1(m, currentTarget), quelle };

  // Korrektur: Ist eine Kachel dieser Phase gewaehlt, wird sie ERSETZT.
  if (secureGewaehlt && secureGewaehlt.phase === 1) {
    const i = secureGewaehlt.index;
    if (i < secureWuerfe.length) {
      const alt = secureWuerfe[i];
      secureWuerfe[i] = {
        ...wurf,
        // Was einen erkannten Dart ersetzt, ist eine Korrektur.
        quelle: alt.quelle === "erkannt" && quelle !== "erkannt" ? "korrigiert" : quelle,
      };
      secureGewaehlt = null;
      secureNeuBerechnen();
      updateTurnDisplay();
      return;
    }
    secureGewaehlt = null;
  }

  if (secureWuerfe.length < MAX_DARTS) {
    secureWuerfe.push(wurf);
    secureNeuBerechnen();
    updateTurnDisplay();
    pruefeSecureAbschluss(quelle);
  }
}

/** @param {number} bull 0 = daneben, 1 = Bull (25), 2 = Bullseye (50)
 *
 *  BEFUND 15.08.2026: Der Parameter hiess `t` und verdeckte damit die
 *  Uebersetzungsfunktion `t()` aus i18n.js. Die Zeile darunter rief
 *  `t("js.secure.007")` auf - also die ZAHL als Funktion. Ueber die Knoepfe
 *  war der Pfad unerreichbar (sie sind bei 0 Rohpunkten gesperrt), ueber den
 *  Tracker nicht: Drei Fehlwuerfe in Phase 1, dann ein erkannter Pfeil aufs
 *  Bull - und es gab einen TypeError statt eines Hinweises. */
function addSecure(bull, quelle = "hand") {
  if (!secureInputAllowed()) return;
  if (currentRawScore === 0) {
    // Kein Treffer in Phase 1 - es gibt nichts zu sichern. Trackerdarts
    // laufen hier still auf, sonst kaeme fuer jeden erkannten Pfeil ein
    // Hinweis, den niemand ausgeloest hat.
    if (quelle !== "erkannt") showToast(t("js.secure.007"), "warning");
    return;
  }

  const wurf = { t: bull, label: secureLabel2(bull), quelle };

  if (secureGewaehlt && secureGewaehlt.phase === 2) {
    const i = secureGewaehlt.index;
    if (i < secureBullWuerfe.length) {
      const alt = secureBullWuerfe[i];
      secureBullWuerfe[i] = {
        ...wurf,
        quelle: alt.quelle === "erkannt" && quelle !== "erkannt" ? "korrigiert" : quelle,
      };
      secureGewaehlt = null;
      secureNeuBerechnen();
      updateTurnDisplay();
      return;
    }
    secureGewaehlt = null;
  }

  if (secureBullWuerfe.length < MAX_DARTS) {
    // BUGFIX 07.08.2026 (0-Bull-Edge-Case): Ein Fehlwurf (t===0) zaehlt nur
    // den Dart hoch; gesichert wird ausschliesslich durch 25 oder 50. Die
    // Staffelung steckt seit 15.08.2026 in secureNeuBerechnen().
    secureBullWuerfe.push(wurf);
    secureNeuBerechnen();
    updateTurnDisplay();
    pruefeSecureAbschluss(quelle);
  }
}

/** Eine Kachel zum Ersetzen auswaehlen (oder die Auswahl aufheben). */
function secureWaehle(phase, index) {
  if (!secureInputAllowed()) return;
  const liste = phase === 1 ? secureWuerfe : secureBullWuerfe;
  if (index >= liste.length) return; // leere Kachel: nichts zu korrigieren
  const gleich =
    secureGewaehlt && secureGewaehlt.phase === phase && secureGewaehlt.index === index;
  secureGewaehlt = gleich ? null : { phase, index };
  updateTurnDisplay();
}

/** Bestaetigt der Tracker die Runde selbst?
 *
 *  Regel (15.08.2026, Alpha-Vorgabe): DREI erkannte Pfeile in der letzten
 *  Phase schliessen die Runde ab. Werden nur zwei erkannt - was bei drei
 *  Bullseyes vorkommt, weil die Pfeile sich verdecken -, passiert nichts;
 *  dann bestaetigt der Mensch.
 *
 *  Bewusst NUR fuer Trackerdarts: Wer von Hand tippt, hat den
 *  Bestaetigen-Knopf direkt daneben und soll seine Eingabe vorher noch
 *  ansehen koennen. */
function pruefeSecureAbschluss(quelle) {
  if (quelle !== "erkannt") return;
  if (secureAutoTimer) clearTimeout(secureAutoTimer);

  const alleErkannt = (liste) =>
    liste.length === MAX_DARTS && liste.every((w) => w.quelle === "erkannt");

  // Phase 1 ohne jeden Treffer: Es gibt keine Phase 2, die Runde ist vorbei.
  const ohneTreffer = alleErkannt(secureWuerfe) && currentRawScore === 0;
  const gesichertFertig = currentRawScore > 0 && alleErkannt(secureBullWuerfe);
  if (!ohneTreffer && !gesichertFertig) return;

  // Kurz stehen lassen: Der dritte Dart soll sichtbar sein, bevor die
  // Runde weiterschaltet.
  secureAutoTimer = setTimeout(() => {
    secureAutoTimer = null;
    if (typeof nextTurn === "function") nextTurn();
  }, 900);
}

/** Drei Kacheln je Phase - dieselbe Gestalt wie in allen anderen Modi.
 *
 *  Sie loesen die drei Punkte (● ● ○) ab: Die sagten nur, WIE VIELE Darts
 *  gezaehlt sind. Seit der Tracker sie fuellt, muss man auch sehen, WELCHE -
 *  und sie antippen koennen, um einen falsch erkannten zu berichtigen. */
function renderSecureSlots(id, wuerfe, phase) {
  const box = document.getElementById(id);
  if (!box) return;
  let html = "";
  for (let i = 0; i < MAX_DARTS; i++) {
    const w = wuerfe[i];
    const gewaehlt =
      secureGewaehlt && secureGewaehlt.phase === phase && secureGewaehlt.index === i;
    html +=
      `<div class="autoscore-dart${gewaehlt ? " is-gewaehlt" : ""}"` +
      ` data-state="${w ? w.quelle : "leer"}" data-phase="${phase}" data-slot="${i}"` +
      ` role="button" tabindex="0">` +
      `<span>${w ? w.label : "–"}</span></div>`;
  }
  box.innerHTML = html;
  if (!box.dataset.verdrahtet) {
    box.dataset.verdrahtet = "1";
    box.addEventListener("click", (e) => {
      const kachel = e.target.closest(".autoscore-dart");
      if (!kachel) return;
      secureWaehle(Number(kachel.dataset.phase), Number(kachel.dataset.slot));
    });
  }
}

function updateTurnDisplay() {
  // Board-Eingabe nachfuehren (lazy aufbauen, Zielfeld setzen).
  aktualisiereSecureBoard();

  const rawScoreEl = document.getElementById("raw-score");
  if (rawScoreEl) rawScoreEl.innerText = currentRawScore;

  renderSecureSlots("score-dots", secureWuerfe, 1);
  renderSecureSlots("secure-dots", secureBullWuerfe, 2);

  const currentTarget = targets[globalTargetIndex];
  const controlsScore = document.getElementById("controls-score");
  const noDartsLeft = thrownScore >= MAX_DARTS || securePhase1Beendet;

  if (controlsScore) {
    const scoreButtons = controlsScore.children;
    // SICHERHEITS-FIX: Klassische For-Schleife (100% kompatibel mit allen Browsern)
    for (let i = 0; i < scoreButtons.length; i++) {
      scoreButtons[i].disabled = noDartsLeft;
    }

    if (!noDartsLeft && scoreButtons.length >= 4) {
      if (currentTarget === 25) {
        scoreButtons[3].disabled = true;
      } else if (currentTarget === 50) {
        scoreButtons[2].disabled = true;
        scoreButtons[3].disabled = true;
      }
    }
  }

  let allowSecure =
    (thrownScore >= MAX_DARTS || securePhase1Beendet) &&
    currentRawScore > 0 &&
    thrownSecure < MAX_DARTS;
  const controlsSecure = document.getElementById("controls-secure");

  if (controlsSecure) {
    const secureButtons = controlsSecure.children;
    // SICHERHEITS-FIX: Klassische For-Schleife
    for (let i = 0; i < secureButtons.length; i++) {
      secureButtons[i].disabled = !allowSecure;
    }
  }

  // Stepper: der Zug ist ein Zwei-Schritte-Prozess, die aktive Karte
  // leuchtet, die abgeschlossene wird abgehakt (siehe KONZEPT_SECURE_LAYOUT.md)
  const step1 = document.getElementById("secure-step-1");
  const step2 = document.getElementById("secure-step-2");
  const inPhase2 = thrownScore >= MAX_DARTS || securePhase1Beendet;
  if (step1) {
    step1.classList.toggle("step-active", !inPhase2);
    step1.classList.toggle("step-done", inPhase2);
  }
  if (step2) {
    step2.classList.toggle("step-active", allowSecure || (inPhase2 && thrownSecure > 0 && thrownSecure < MAX_DARTS));
    step2.classList.toggle(
      "step-done",
      inPhase2 && (thrownSecure >= MAX_DARTS || currentRawScore === 0),
    );
  }

  let txt = isSecured
    ? tf("js.secure.gesichert", { p1: secureMultiplier })
    : t("js.secure.018");
  if (inPhase2 && currentRawScore === 0) {
    txt = t("js.secure.008");
  } else if (inPhase2 && thrownSecure >= MAX_DARTS && !isSecured) {
    // Drei Sicherungs-Darts geworfen, kein Bull getroffen: klar benennen,
    // statt weiter "Offen" anzuzeigen (0-Bull-Edge-Case, 07.08.2026).
    txt = t("js.secure.009");
  }

  const secureStatusEl = document.getElementById("secure-status");
  if (secureStatusEl) {
    secureStatusEl.innerText = txt;
    secureStatusEl.style.color = isSecured ? "var(--accent-green)" : "#aaa";
  }

  // Kombinierte Ergebniszeile: "34 × 2 = 68" bzw. "34 × ungesichert = 0"
  const calcEl = document.getElementById("secure-result-calc");
  if (calcEl) {
    calcEl.innerText = isSecured
      ? tf("js.secure.019", { p1: currentRawScore, p2: secureMultiplier })
      : tf("js.secure.020", { p1: currentRawScore });
  }

  const roundResultEl = document.getElementById("round-result");
  if (roundResultEl) {
    roundResultEl.innerText = isSecured
      ? currentRawScore * secureMultiplier
      : 0;
  }
}

// Ausklappbare Rangliste unter dem Karussell
function toggleSecureLeaderboard() {
  const panel = document.getElementById("leaderboard-panel");
  const chevron = document.getElementById("leaderboard-chevron");
  if (!panel) return;
  const open = panel.style.display === "none";
  panel.style.display = open ? "block" : "none";
  if (chevron) chevron.innerText = open ? "▾" : "▸";
}

function resetTurnInputs() {
  if (secureAutoTimer) {
    clearTimeout(secureAutoTimer);
    secureAutoTimer = null;
  }
  secureWuerfe = [];
  secureBullWuerfe = [];
  secureGewaehlt = null;
  securePhase1Beendet = false;
  isDoubleHit = false;
  // Alles Weitere leitet sich aus den (jetzt leeren) Listen ab.
  secureNeuBerechnen();
  updateTurnDisplay();
}

// Die Sprachsteuerung (toggleVoice/processVoiceCommand + SpeechRecognition)
// wurde komplett entfernt. Sie war nur fuer Secure Darts verdrahtet, hat
// haeufig Fehleingaben produziert und den Screen mit dem Mikrofon-Button
// ueberladen. Eingaben laufen ausschliesslich ueber die Buttons.

function updateUI() {
  const player = players[currentPlayerIndex];
  if (!player) return; // Prevent crash if player isn't loaded yet

  const nameEl = document.getElementById("current-player-name");
  if (nameEl) nameEl.innerHTML = secureNameHtml(player);

  const scoreEl = document.getElementById("current-player-score");
  if (scoreEl) scoreEl.innerText = player.score;

  let ziel = targets[globalTargetIndex];
  const targetDisplay = document.getElementById("current-target");
  if (targetDisplay) {
    targetDisplay.innerText =
      ziel === 25 ? "BULL" : ziel === 50 ? "BULLSEYE" : ziel;
  }

  updateSecureCarousel();
  updateLiveLeaderboard();
  updateUndoButtonVisibility();
}

// Zug-Reihenfolge als Karussell: bei 2 Spielern links/rechts,
// ab 3 Spielern Vorheriger - Aktiv - Naechster.
function updateSecureCarousel() {
  if (typeof renderPlayerCarousel !== "function") return;
  renderPlayerCarousel(
    "secure-carousel",
    players.map((p) => ({
      name: secureName(p),
      score: p.score,
      sub: p.isBot ? t("js.g501.032") : "",
    })),
    currentPlayerIndex,
    { accent: "var(--accent-green)" },
  );
}

function updateLiveLeaderboard() {
  const list = document.getElementById("live-leaderboard-list");
  list.innerHTML = "";

  const sortedPlayers = [...players].sort((a, b) => b.score - a.score);

  sortedPlayers.forEach((p, index) => {
    const isLeader = index === 0 && p.score > 0;
    const isActive = p === players[currentPlayerIndex];

    const row = document.createElement("div");

    // Sauberes Layout im modernen Glass-Design
    row.style.cssText = `
      display: flex; 
      justify-content: space-between; 
      align-items: center;
      padding: 12px 18px; 
      margin-bottom: 10px; 
      border-radius: 8px;
      background: ${isActive ? "var(--accent-green)" : "rgba(0,0,0,0.3)"};
      color: ${isActive ? "#000" : "#fff"};
      border: 1px solid ${isActive ? "var(--accent-green)" : "var(--glass-border)"};
      box-shadow: ${isActive ? "0 0 15px rgba(16, 185, 129, 0.4)" : "none"};
      transition: all 0.3s ease;
    `;

    let nameDisplay = secureNameHtml(p);
    if (isLeader) nameDisplay = `👑 ${nameDisplay}`;

    row.innerHTML = `
      <span style="font-weight: ${isActive ? "900" : "bold"}; font-size: 1.1em;">${nameDisplay}</span>
      <span style="font-size: 1.4em; font-weight: 900;">${p.score} <span style="font-size: 0.6em; font-weight: normal; opacity: 0.8;">Pkt</span></span>
    `;
    list.appendChild(row);
  });
}

function cancelSecureGame() {
  // BUGFIX "Abbrechen schliesst das Spiel nicht final":
  // 1) cancelCurrentGame() versteckte nur den Screen - players und
  //    gameHistoryStack blieben gefuellt. showScreen('play') routet aber
  //    ueber players.length und sprang beim naechsten Betreten des Modus
  //    direkt wieder ins alte, "abgebrochene" Spiel.
  // 2) Ein laufender botTimer feuerte nach dem Abbrechen weiter (playBot/
  //    nextTurn auf verstecktem Screen - bis hin zum Spielende samt Toast).
  // 3) Online wurde der Raum schon VOR der Bestaetigung geschlossen - ein
  //    "Nein" im Dialog liess den Gegner trotzdem in einem toten Raum.
  // Jetzt laeuft ALLES erst nach dem Ja im Bestaetigungsdialog.
  showCancelModal(() => {
    if (botTimer) {
      clearTimeout(botTimer);
      botTimer = null;
    }

    // Online: Raum sauber schliessen bzw. Platz freigeben
    if (typeof isSecureOnline !== "undefined" && isSecureOnline) {
      cancelSecureOnlineGame();
    }

    // Spielzustand endgueltig verwerfen
    secureSpielBeendet = false;
    players = [];
    gameHistoryStack = [];
    currentPlayerIndex = 0;
    globalTargetIndex = 0;
    resetTurnInputs();

    const setupList = document.getElementById("player-list-setup");
    if (setupList) setupList.innerHTML = "";
    const botOverlay = document.getElementById("bot-overlay");
    if (botOverlay) botOverlay.style.display = "none";

    // Bestaetigung ist bereits erfolgt -> Restaufraeumen ohne zweiten Dialog
    cancelCurrentGame("game-secure-screen", true);
  });
}

// ── Auto-Score-Adapter (autoscore.js, 13.08.2026) ──────────────────────────
//
// Secure ist ein Pro-Dart-Modus mit zwei Phasen je Runde: erst drei Darts
// auf das Rundenziel (addRawScore mit dem getroffenen Multiplikator), nach
// dem Ziehen drei Darts auf das Bull (addSecure). Der Tracker liefert
// base/mult je Dart - daraus ergibt sich die Eingabe direkt; die gesamte
// Wertung (Multiplikator-Staffelung, Bull-Sonderfaelle, Rundenwechsel)
// bleibt unveraendert in den vorhandenen Funktionen. Bestaetigt wird die
// Runde weiterhin von Hand (nextTurn) - und bei einem Fehltracking sind
// Reset + Handeingabe der Korrekturweg, deshalb korrigierbar: false
// (ein angetippter Dart ist hier laengst verwertet).
function autoscoreSecureDart(dart) {
  // Online: Wuerfe des Gegners kommentarlos verwerfen - der Toast von
  // secureInputAllowed() gehoert zu HANDEINGABEN, nicht zu jedem
  // Trackerereignis waehrend des Gegnerzugs.
  if (typeof canInputSecure === "function" && !canInputSecure()) return;

  // Zuordnung ueber die gemeinsame Wertungslogik (secureDartEinordnen) -
  // dieselbe, die der Board-Klick benutzt. Eine gewaehlte Kachel bestimmt
  // weiterhin, WOHIN der Dart gehoert (Korrektur).
  const zuordnung = secureDartEinordnen(
    Number(dart?.base ?? 0),
    Number(dart?.mult ?? 1),
  );
  if (zuordnung.phase === 1) {
    // Phase 1: Punkten auf das Rundenziel. Ein Dart daneben zaehlt als
    // Fehlwurf (m = 0) - er verbraucht den Dart, wie die 0-Taste.
    addRawScore(zuordnung.wert, "erkannt");
  } else if (secureBullWuerfe.length < MAX_DARTS || secureGewaehlt) {
    // Phase 2: Sichern auf das Bull.
    addSecure(zuordnung.wert, "erkannt");
  }
  // Beide Phasen voll: Nachzuegler verfallen - die Runde wartet auf
  // "Bestaetigen" (nextTurn) bzw. Reset.
}

/** Pfeile gezogen: die laufende Phase ist vorbei.
 *
 *  Das ist der Fall, den die Zaehler allein nicht abdecken: Werden nur zwei
 *  von drei Pfeilen erkannt - bei drei Bullseyes verdecken sie sich -, wird
 *  `secureWuerfe.length` nie 3, und Phase 2 oeffnete nie. Das Ziehen der
 *  Pfeile sagt es stattdessen. Bestaetigt wird dabei NICHTS: Nach einer
 *  unvollstaendigen Erkennung soll ein Mensch draufschauen. */
function securePhase1Abschluss() {
  securePhase1Beendet = true;
  updateTurnDisplay();
}

function securePhaseAbschliessen() {
  if (!secureWuerfe.length) return; // noch gar nichts erkannt
  if (!securePhase1Beendet) {
    securePhase1Abschluss();
    return;
  }
  // Phase 2 ist gezogen - mehr passiert bewusst nicht: Der Abschluss der
  // Runde haengt an drei ERKANNTEN Pfeilen (pruefeSecureAbschluss), sonst
  // am Menschen.
  updateTurnDisplay();
}

window.autoScoreAdapter = window.autoScoreAdapter || {};
window.autoScoreAdapter.secure = {
  // Korrigiert wird in DEN Kacheln des Modus, nicht im Autoscore-Kasten:
  // Secure hat zwei Phasen mit verschiedener Bedeutung (Multiplikator aufs
  // Ziel, dann Bull) - ein Feldgitter im Kasten wuesste nicht, welche
  // gemeint ist.
  korrigierbar: false,
  eigeneSlots: true,
  aktiv: () =>
    document.getElementById("game-secure-screen")?.style.display !== "none",
  ziel: () => document.getElementById("secure-input-area"),
  dart: (dart) => {
    autoscoreSecureDart(dart);
    return null; // kein vorzeitiger Abschluss - das entscheidet der Modus
  },
  // Pfeile gezogen: Das ist das ehrlichste Signal dafuer, dass eine Phase
  // vorbei ist - auch wenn nur zwei Pfeile erkannt wurden (drei Bullseyes
  // verdecken sich gegenseitig). Ohne diese Zeile blieb die Runde in
  // Phase 1 stehen und Phase 2 oeffnete nie.
  geleert: () => securePhaseAbschliessen(),
};

// ---------------------------------------------------------------
// Bruecke zu window: Inline-Handler im HTML und andere Module greifen
// weiterhin global auf diese Funktionen zu. Automatisch erzeugt beim
// Umstieg auf Vite - Modul-Scope ersetzt sonst die alten Globals.
// ---------------------------------------------------------------
Object.assign(window, {
  secureWaehle,
  secureBoardWurf,
  aktualisiereSecureBoard,
  addPlayer,
  addVerifiedPlayer,
  addBot,
  addBotWithDifficulty,
  startGame,
  cancelBotAndUndo,
  undoLastTurn,
  nextTurn,
  addRawScore,
  addSecure,
  resetTurnInputs,
  updateUI,
  toggleSecureLeaderboard,
  cancelSecureGame,
  secureRevanche,
  secureBeenden,
  secureSpielFreigeben,
});
